import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { addBanner, getBanners, getSlc } from "../../reducers/commonReducer";

const schema = yup.object().shape({
  name: yup.string().required("Name is required."),
  fatherName: yup.string().required("Father Name is required."),
  slcNo: yup.mixed().required("Please Upload Mobile Image."),
});

function SlcAction(props) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const {title, api, name, slcNo, fatherName, id} = props
  return (
    <>
      <Button variant="success" onClick={handleShow}>
       {title} SLC
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title} SLC</Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={schema}
          onSubmit={async (values, { resetForm }) => {
            await dispatch(api(values));
            resetForm({ values: "" });
            dispatch(getSlc())
            setShow(false)
          }}
          initialValues={{
            name, slcNo, fatherName, id, slc:''
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            setFieldValue,
            errors,
          }) => (
            <Form className="container" onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group >
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Name"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group >
                    <Form.Label>Father Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Father Name"
                      name="fatherName"
                      value={values.fatherName}
                      onChange={handleChange}
                      isInvalid={!!errors.fatherName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.fatherName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
              <Col md={6}>
                  <Form.Group >
                    <Form.Label>SLC No.</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="SLC Number"
                      name="slcNo"
                      value={values.slcNo}
                      onChange={handleChange}
                      isInvalid={!!errors.slcNo}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.slcNo}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6} className="mb-1">
                    <Form.Group>
                      <Form.Label>SLC Upload</Form.Label>
                      <Form.Control
                        type="file"
                        name="slc"
                        onChange={(event) => {
                          const img = event.target.files[0];
                          setFieldValue("slc", img);
                        }}
                        isInvalid={!!errors.slc}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.slc}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
              </Row>
              <Modal.Footer>
                <Button variant="success" type="submit">
                  Submit
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

export default SlcAction;
